import React, { useCallback, useState } from 'react';
import { BASE_URL } from '../shared/constants';
import ProductDiscountImage from './ProductDiscountImage';
import ProductImageLightbox from './ProductImageLightbox';
import '../styles/product-photo.css';

const ProductPhoto = ({ image, name, price, discountedPrice, personalDiscount, productDiscount, className = '' }) => {
  const [open, setOpen] = useState(false);
  const close = useCallback(() => setOpen(false), []);
  const src = image ? `${BASE_URL}/api/v1/product/image/${image}` : '';

  return <>
    <ProductDiscountImage as='button' type='button' price={price} discountedPrice={discountedPrice}
      personalDiscount={personalDiscount} productDiscount={productDiscount}
      className={`product-photo-button ${className}`.trim()} disabled={!image}
      aria-label={`Переглянути фото: ${name}`} aria-haspopup='dialog' onClick={() => setOpen(true)}>
      {image ? <img src={src} alt={name} />
        : <span className='product-photo-placeholder' aria-hidden='true'><i className='bi bi-image' /></span>}
    </ProductDiscountImage>
    {open && image && <ProductImageLightbox src={src} alt={name} onClose={close} />}
  </>;
};

export default ProductPhoto;
